'use client';

import { createContext, useEffect, useState } from 'react';

import { UserData } from '@/types/UserData';

export const UserDataContext = createContext<UserData | undefined>(undefined);

export const UserDataProvider = (props: ProviderProps): JSX.Element => {
  const userDataSessionKey = 'USER_DATA';
  const [user, setUser] = useState(props.userData);
  useEffect(() => {
    const fetchUser = () => {
      const sessionUserValue = sessionStorage.getItem(userDataSessionKey);
      if (props.userData) {
        sessionStorage.setItem(userDataSessionKey, JSON.stringify(props.userData));
        setUser(props.userData);
      } else if (sessionUserValue) {
        setUser(JSON.parse(sessionUserValue) as UserData);
      }
    };
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <UserDataContext.Provider value={user}>{props.children}</UserDataContext.Provider>;
};

interface ProviderProps {
  userData: UserData;
  children: JSX.Element;
}
